import { uri } from 'utils';

import types from '../types';

/**
 * @param {types.CheckBoxOrRadioOption[]} options
 * @param {types.FilterRadio} [radio] accordion type of filter has radio button
 * @returns {?string}
 */
const getURLValueFromActiveInputs = (options, radio = null) => {
    if (!options || !Array.isArray(options) || !options.length) {
        return null;
    }

    const checkedOptions = [];

    // collect active options
    options.forEach(filter => {
        if (filter.checked) {
            checkedOptions.push(filter.value.toString());
        }

        if (
            filter.checked &&
            filter.subcategoriesContent &&
            filter.subcategoriesContent.subcategories &&
            filter.subcategoriesContent.subcategories.length
        ) {
            const { subcategories } = filter.subcategoriesContent;

            const checkedSubcategories = subcategories.filter(
                item => item.checked
            );

            if (checkedSubcategories.length) {
                checkedSubcategories.forEach(item => {
                    checkedOptions.push(item.value.toString());
                });
            }
        }
    });

    if (checkedOptions.length) {
        return checkedOptions.join(uri.VALUE_SEPARATOR);
    }

    if (radio && radio.checked) {
        return radio.value.toString();
    }

    return null;
};

export default getURLValueFromActiveInputs;
